module.exports = __webpack_public_path__ + "static/media/calendarFilter.20d6e5a7.svg";